var map = {
	"./msg.vue": "jflh",
	"./typebutton.vue": "ssOx"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "K8cs";


//////////////////
// WEBPACK FOOTER
// ./src/plugins \.vue$
// module id = K8cs
// module chunks = 0